import React from "react";
import { List } from "@refinedev/mui";
import { Grid2 as Grid } from "@mui/material";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CollectionsBookmarkIcon from "@mui/icons-material/CollectionsBookmark";
import DownloadIcon from "@mui/icons-material/Download";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import NewspaperIcon from "@mui/icons-material/Newspaper";

import { DataGrid } from "@shared/components/DataGrid";
import { FilterDropdown, SummaryCard } from "@shared/components";
import { DownloadBookListFilters } from "@modules/downloadBooks/components";

import { useDownloadBookList } from "./controller";
import { useDownloadBookListColumns } from "./columns";

export const DownloadBookList = React.memo(() => {
  const {
    rows,
    loading,
    rowCount,
    tableProps,
    monthlyReport,
    isLoadingReport,
  } = useDownloadBookList();

  const columns = useDownloadBookListColumns();
  const statistics = monthlyReport?.statistics;

  return (
    <List
      headerButtons={
        <FilterDropdown
          initialValues={{
            agreement_id: "",
            product_id: "",
            document: "",
            book_month: "",
            book_year: "",
            download_month: "",
            download_year: "",
            book_type: "",
            isbn: "",
            issn: "",
          }}
        >
          <DownloadBookListFilters />
        </FilterDropdown>
      }
    >
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <SummaryCard
            icon={<DownloadIcon />}
            label="Total de Downloads"
            value={statistics?.total_downloads?.toLocaleString("pt-BR") ?? "—"}
            loading={isLoadingReport}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <SummaryCard
            icon={<CollectionsBookmarkIcon />}
            label="Total de Mídias"
            value={statistics?.total_media?.toLocaleString("pt-BR") ?? "—"}
            loading={isLoadingReport}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <SummaryCard
            icon={<CalendarMonthIcon />}
            label="Períodos"
            value={statistics?.total_periods?.toLocaleString("pt-BR") ?? "—"}
            loading={isLoadingReport}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <SummaryCard
            icon={<AutoStoriesIcon />}
            label="E-books"
            value={statistics?.total_ebooks?.toLocaleString("pt-BR") ?? "—"}
            loading={isLoadingReport}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <SummaryCard
            icon={<HeadphonesIcon />}
            label="Audiobooks"
            value={statistics?.total_audiobooks?.toLocaleString("pt-BR") ?? "—"}
            loading={isLoadingReport}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <SummaryCard
            icon={<NewspaperIcon />}
            label="Revistas"
            value={statistics?.total_magazines?.toLocaleString("pt-BR") ?? "—"}
            loading={isLoadingReport}
          />
        </Grid>
      </Grid>

      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        rowCount={rowCount}
      />
    </List>
  );
});
